import { CreateNewFieldData } from '../types';
import axios from '../../../services/axios';

const CROPWISE_API_BASE_URL = import.meta.env.VITE_APP_CROPWISE_API_URL;

export const createNewField = async (access_token: string, data: CreateNewFieldData | null) => {
  try {
    const response: any = await axios.request({
      method: 'POST',
      url: `${CROPWISE_API_BASE_URL}/v2/fields`,
      headers: { Authorization: `Bearer ${access_token}` },
      data,
    });
    return response.data.id;
  } catch (err: any) {
    console.error('createNewField error:', err);
    return err;
  }
};
